import React, { useEffect, useState } from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';

import classes from './ServiceManagement.module.css';

const ServiceManagement = ({
    history,
    targetNavCompany,
    ...props
}) => {
    const [companyName, setCompanyName] = useState();

    useEffect(() => {
        const init = async () => {
            setCompanyName(targetNavCompany.name);
        };
        if (targetNavCompany && targetNavCompany.id) init();
    }, [targetNavCompany]);

    return (
        <BobPage>
            <div className={classes.ServiceManagement}>
                <div className={classes.CompanyNamePanel}>
                    {companyName}
                </div>
                <div className={classes.HeaderPanel}>
                    Service Requests
                </div>
                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    <TableContainer />
                </div>
            </div>
        </BobPage>
    );
};

ServiceManagement.defaultProps = {
    targetNavCompany: {},
};

ServiceManagement.propTypes = {
    targetNavCompany: object
};

const mapStateToProps = state => {
    return {
        targetNavCompany: state.bob.targetNavCompany
    };
};

export default withRouter(connect(mapStateToProps)(ServiceManagement));
